// Neo's status on home can be dismissed (TOM-683, Mike 2026-10-16): hidden in
// this browser until Neo writes something else. It is a convenience for one
// viewer, so it is kept in this browser's storage, per boat; a storage that
// is unavailable or throws keeps the status shown.

import type { NeoStatus } from '@neomaris/protocol';

const KEY = 'tombolo.home.statusDismissed.';

/**
 * What the owner read: the body and the thing to watch. The time Neo wrote it
 * is left out, so the same words written again stay dismissed.
 */
export function statusWords(status: NeoStatus): string {
  const watch = status.watch;
  return JSON.stringify([
    status.body,
    watch === null ? null : [watch.key, watch.title, watch.body],
  ]);
}

/** The words the owner last dismissed on this boat's home, or null. */
export function readDismissedStatus(boatId: string): string | null {
  try {
    return localStorage.getItem(KEY + boatId);
  } catch {
    return null;
  }
}

export function writeDismissedStatus(boatId: string, words: string): void {
  try {
    localStorage.setItem(KEY + boatId, words);
  } catch {
    // Not kept: it is dismissed until the page reloads.
  }
}
